import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appDialogTemplateFooterActionsFirst]',
})
export class DialogTemplateFooterActionsFirstDirective {

  constructor(public tplRef: TemplateRef<any>) {
  }

}
